import { AppContentView } from 'Components/AppLayout';
import { SITE_PAGES } from 'Config';
import PropTypes from 'prop-types';
import { isUserAuthorized } from 'Util';

const AdminLanding = ({
  title = '',
  breadcrumbs = [],
  children,
  titleButton,
}) => {
  let allBreadcrumbs = [
    // getBreadcrumb(SITE_PAGES.ADMIN_LANDING),
    ...breadcrumbs,
  ];

  let navLinks = [SITE_PAGES.MANAGE_USERS].filter((page) =>
    isUserAuthorized(page.requiredAuth),
  );

  return (
    <AppContentView
      landingTitle={title}
      titleButton={titleButton}
      breadcrumbs={breadcrumbs ? allBreadcrumbs : undefined}
      links={navLinks}
      pageTitle={title}>
      {children}
    </AppContentView>
  );
};

AdminLanding.propTypes = {
  title: PropTypes.string,
  breadcrumbs: PropTypes.array,
  children: PropTypes.node,
  titleButton: PropTypes.node,
};

export default AdminLanding;
